import { defineComponent, createElementBlock, openBlock, Fragment, renderList, createElementVNode, createVNode } from 'vue';
import _sfc_main$1 from './basler-components.es87.js';
/* empty css                       */

const _hoisted_1 = { class: "attributes" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = { class: "attribute-name" };
const _hoisted_4 = { class: "attribute-value" };
const _hoisted_5 = { key: 1 };
const _hoisted_6 = ["innerHTML"];
const _hoisted_7 = ["innerHTML"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "AttributeTable",
  props: {
    attributes: {},
    isLoading: { type: Boolean, default: false },
    loadingLines: { default: 3 }
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        _ctx.isLoading ? (openBlock(), createElementBlock("div", _hoisted_2, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.loadingLines, (index) => {
            return openBlock(), createElementBlock("div", {
              key: index,
              class: "attribute-item"
            }, [
              createElementVNode("div", _hoisted_3, [
                createVNode(_sfc_main$1, { class: "attributes__loading-content" })
              ]),
              createElementVNode("div", _hoisted_4, [
                createVNode(_sfc_main$1, { class: "attributes__loading-content" })
              ])
            ]);
          }), 128))
        ])) : (openBlock(), createElementBlock("div", _hoisted_5, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(props.attributes, (attribute, index) => {
            return openBlock(), createElementBlock("div", {
              key: index,
              class: "attribute-item"
            }, [
              createElementVNode("div", {
                class: "attribute-name",
                innerHTML: attribute.label
              }, null, 8, _hoisted_6),
              createElementVNode("div", {
                class: "attribute-value",
                innerHTML: attribute.value
              }, null, 8, _hoisted_7)
            ]);
          }), 128))
        ]))
      ]);
    };
  }
});

export { _sfc_main as default };
